import React, { PureComponent } from 'react';
import { Col, Container, Row } from 'reactstrap';
import Control from './controlGridQuestionnaire';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ComplianceCard from './conponents/compliance-card'
import ChevronRight from 'mdi-react/ChevronRightIcon';
import ChevronLeft from 'mdi-react/ChevronLeftIcon';
import $ from 'jquery';
import categories from './conponents/deafult-categories'

import { signout } from '../../redux/actions/userActions';

class VendorQuestionnaire extends PureComponent {

  state = {
    categories: categories,
    controls: [],
    loading: false,
    loaded: true,
    users: [],
    totalControls: 47,
    compliantControlsTotal: 0,
    selectedCategory: 0,
    scrolling: false,
    updateGrid: true
  }

  componentWillMount () {
    return this.props.user ? null : this.props.history.push('/unauthorized');
  }

  signoutUser () {
    this.props.signout();
    this.props.history.push('/');
  }

  setUpdate = (title, active) => {
    this.setState({ updateGrid: (title !== active) })
  }

  renderSlideCards () {
    return this.state.categories.map((category, i) => {
      let percentageCal = (category.compliantControlsTotal / category.controlsTotal * 100).toFixed(0)
      return <div key={category.name} style={{ marginRight: 20 }}>
        <ComplianceCard
          id={i}
          category={category.name}
          percentage={100-percentageCal}
          changeCategory={this.selectNewCatagory.bind(this)}
          numberCompliance={category.compliantControlsTotal}
          totalControls={category.controlsTotal}
          clickable={true}
          percentage_color={percentageCal > 0 ? "#2d9aa6" : "#C6C6C6"} //#3DA3FC
          hoverColor={true}
          isActive={this.state.selectedCategory === i ? true : false}
          setUpdate={this.setUpdate}
          bgColor="white-bg"
          selectedCatName={this.state.categories[this.state.selectedCategory]}
        />
      </div>
    })
  }

  selectNewCatagory (category) {
    this.setState({ selectedCategory: category });
  }

  scrollContent (direction) {
    const step = 370;

    $("#card-content").animate({
      scrollLeft: `${direction === 'left' ? '-=' : '+='}` + step + "px"
    });
  }

  render () {
    const { loaded } = this.state;
    const { navigationStyle } = styles;
    return (
      <Container>
        <Row>
          {!loaded && <div className={`custom_load load${this.state.loading ? '' : ' loaded'}`}>
            <div className='load__icon-wrap'>
              <svg className='load__icon'>
                <path fill='#2d9aa6' d='M12,4V2A10,10 0 0,0 2,12H4A8,8 0 0,1 12,4Z' />
              </svg>
            </div>
          </div>}
          <Col md={12} id="test">
            <h3 className='page-title'>{this.props.compliance} Vendor Assessments</h3>
            <h3 className='page-subhead subhead'>View your vendors' assessments</h3>
          </Col>
        </Row>

        <Row>

          <Col>
            <div className="arrow-left">
              <div
                style={navigationStyle}
                onClick={() => this.scrollContent('left')}>
                <ChevronLeft id='scrollUp' size={60} color={'#C6C6C6'} />
              </div>
            </div>
            {/*<ProjectTeam />*/}
            <div style={{ display: 'flex', flexDirection: 'row' }}>

              <div id="staticComplianceCard" style={{ marginRight: 20 }}>
                <ComplianceCard
                  title="Risk Assessment Score"
                  percentage={100-((this.state.compliantControlsTotal / this.state.totalControls * 100).toFixed(0))}
                  numberCompliance={this.state.compliantControlsTotal}
                  totalControls={this.state.totalControls}
                  clickable={false}
                  percentage_color="#2d9aa6"
                  bgColor="no-bg"
                />
              </div>
              <div id='card-content' style={{ display: 'flex', flexDirection: 'row', overflowY: 'scroll' }}>
                {this.renderSlideCards()}
              </div>

            </div>

            <div className="arrow-right"> <div
              style={navigationStyle}
              onClick={() => this.scrollContent('right')}>
              <ChevronRight id='scrollDown' size={60} color={'#C6C6C6'} />
            </div>
            </div>

          </Col>

          <Control
            title='Vendor Assessment'
            categories={[this.state.categories[this.state.selectedCategory]]}
            update={this.state.updateGrid}
            setUpdate={this.setUpdate}
            selectedCatName={this.state.categories[this.state.selectedCategory]}
          />
        </Row>
      </Container >
    )
  }
}

const styles = {
  navigationStyle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer'
  }
}

function mapStateToProps (state) {
  return {
    user: state.auth.user
  }
}

export default connect(mapStateToProps, { signout })(withRouter(VendorQuestionnaire));


// WEBPACK FOOTER //
// ./src/components/vendor_assessments/VendorQuestionnaire.js